<template>
    <v-card class="elevation-0" style="width: 500px; max-width: 500px; max-height: 500px">
        <v-toolbar card dense dark flat color="primary">
            <v-toolbar-title><h4>Notificaciones</h4></v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items>
                <template v-if="LOAD_UNREAD_NOTIFICACIONES">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click="timerShow = !timerShow">
                                <v-icon medium v-on="on">fa-clock-o</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ "Cargando notificaciones sin leer cada " + timer + " s" }}</span>
                    </v-tooltip>

                    <v-expand-x-transition>
                        <v-text-field
                            hide-details
                            solo
                            v-show="timerShow"
                            v-model="timer"
                            placeholder="valor"
                            suffix="s"
                            type="number"
                            min="1"
                            @keypress.enter="applyTimer()"
                            style="max-width: 130px"
                        >
                        </v-text-field>
                    </v-expand-x-transition>
                </template>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon flat>
                            <v-icon medium v-on="on" @click="toogleLoadNotificaciones()">{{
                                LOAD_UNREAD_NOTIFICACIONES ? "fa-bell" : "fa-bell-slash"
                            }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{
                        LOAD_UNREAD_NOTIFICACIONES ? "Cargando notificaciones" : "Notificaciones silenciadas"
                    }}</span>
                </v-tooltip>
            </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <v-list class="pa-0">
                <v-slide-y-transition class="py-0" group tag="v-list">
                    <template v-for="(item, index) in USER_UNREAD_NOTIFICACIONES">
                        <v-divider v-if="index !== 0" :key="`divider-${index}`"></v-divider>
                        <v-list-tile :key="`tile-${index}`">
                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.notificationGestor.nombre"></v-list-tile-title>
                                <v-list-tile-sub-title class="caption" v-html="item.notificationGestor.descripcion">
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div class="action-column">
                                            <v-btn
                                                icon
                                                flat
                                                dark
                                                color="success"
                                                :loading="loading"
                                                @click="modificarLectura(item)"
                                            >
                                                <v-icon size="22px" v-on="on">fa-eye</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Marcar como vista</span>
                                </v-tooltip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                </v-slide-y-transition>

                <v-flex py-4 v-if="!USER_UNREAD_NOTIFICACIONES.length" class="text-xs-center">
                    <h5>No existen notificaciones sin leer</h5>
                </v-flex>
            </v-list>

            <v-divider></v-divider>
            <v-btn block color="success lighten-1" flat dark class="ma-0" @click="viewAllNotifications()">Todas</v-btn>
            <v-divider></v-divider>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    data: () => ({
        loading: false,
        fetchNotificationsInterval: null,

        //para establecer tiempo en las paticiones de las notificaciones
        timerShow: false,
        timer: 30
    }),
    methods: {
        loadUnreadNotifications() {
            this.$store.dispatch("LOAD_USER_UNREAD_NOTIFICACIONES", this.CURRENT_USER)
        },

        //pidiendo las notificaciones cada 30s
        load() {
            this.fetchNotificationsInterval = setInterval(() => {
                this.loadUnreadNotifications()
            }, this.TIMER_UNREAD_NOTIFICACIONES * 1000)
            return this.fetchNotificationsInterval
        },

        modificarLectura(item) {
            this.loading = true
            this.$store.dispatch("UPDATE_USER_UNREAD_NOTIFICACION", item).then(() => {
                this.loading = false
                this.loadUnreadNotifications()
            })
        },

        viewAllNotifications() {
            this.$router.push({ name: "user-notificacion" })
            this.cancelMenu()
        },

        cancelMenu() {
            this.$emit("menuCanceled")
        },

        toogleLoadNotificaciones() {
            this.$store.commit("TOOGLE_LOAD_UNREAD_NOTIFICACIONES")
            if (this.LOAD_UNREAD_NOTIFICACIONES) {
                this.loadUnreadNotifications()
                this.load()
            } else {
                clearInterval(this.fetchNotificationsInterval)
            }
        },

        applyTimer() {
            if (!this.timerShow) {
                this.timerShow = true
            } else {
                if (this.timer !== this.TIMER_UNREAD_NOTIFICACIONES) {
                    this.$store.commit("SET_TIMER_UNREAD_NOTIFICACIONES", this.timer)
                    if (this.LOAD_UNREAD_NOTIFICACIONES) {
                        clearInterval(this.fetchNotificationsInterval)
                        this.loadUnreadNotifications()
                        this.load()
                    }
                }
                this.timerShow = false
            }
        }
    },
    computed: {
        ...mapGetters([
            "USER_UNREAD_NOTIFICACIONES",
            "CURRENT_USER",
            "LOAD_UNREAD_NOTIFICACIONES",
            "TIMER_UNREAD_NOTIFICACIONES"
        ])
    },
    mounted() {
        //inicializando el timer para pedir las notificaciones
        if (this.LOAD_UNREAD_NOTIFICACIONES) {
            this.loadUnreadNotifications()
            this.load()
        }

        this.timer = this.TIMER_UNREAD_NOTIFICACIONES
    },
    destroyed() {
        //eliminando el timer de las notificaciones
        clearInterval(this.fetchNotificationsInterval)
    }
}
</script>

<style>
div.action-column {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -webkit-transition: opacity 0.3s ease-in-out;
}

.v-list__tile:hover div.action-column {
    opacity: 1;
}
</style>
